import { ResponsiveLine } from '@nivo/line';

type DataPoint = {
  x: string;
  y: number;
};

export type LineData = {
  id: string;
  label: string;
  color: string;
  data: DataPoint[];
};

type LineProps = {
  data: LineData[];
};

const Line = ({ data }: LineProps) => {
  return (
    <ResponsiveLine
      data={data}
      colors={(d) => d.color}
      animate={true}
      margin={{ top: 20, right: 40, bottom: 50, left: 40 }}
      xScale={{
        type: 'time',
        format: '%Y-%m-%d',
        precision: 'day',
      }}
      xFormat="time:%Y-%m-%d"
      yScale={{
        type: 'linear',
        min: 0,
        max: 'auto',
        stacked: false,
        reverse: false,
      }}
      yFormat=" >-.0f"
      curve="linear"
      axisTop={null}
      enableSlices={'x'}
      sliceTooltip={({ slice }) => {
        return (
          <div
            style={{
              background: 'white',
              padding: '9px 12px',
              border: '1px solid #ccc',
              fontSize: '12px',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            <div>
              <strong>{slice.points[0].data.xFormatted}</strong>
              {slice.points.map((point) => (
                <div
                  key={point.id}
                  style={{
                    padding: '3px 0',
                    lineHeight: '12px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: point.serieColor,
                        width: '12px',
                        height: '12px',
                        marginRight: '6px',
                        borderRadius: '6px',
                      }}
                    ></div>
                    <div style={{ fontSize: '12px' }}>
                      {point.serieId} - {point.data.yFormatted}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      }}
      axisRight={null}
      axisBottom={{
        format: '%Y-%m-%d',
        tickSize: 5,
        tickValues: 5,
        tickPadding: 3,
        tickRotation: 0,
        legendOffset: 36,
        legendPosition: 'middle',
      }}
      axisLeft={{
        tickSize: 5,
        tickValues: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: -40,
        legendPosition: 'middle',
      }}
      enableGridX={true}
      enableGridY={true}
      pointSize={8}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={2}
      pointBorderColor={{ from: 'serieColor' }}
      pointLabelYOffset={-12}
      useMesh={true}
      legends={[
        {
          anchor: 'bottom-right',
          direction: 'row',
          justify: false,
          translateX: 30,
          translateY: 50,
          itemsSpacing: 20,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'circle',
          symbolBorderColor: 'rgba(0, 0, 0, .5)',
          effects: [
            {
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      theme={{
        text: {
          fontFamily: 'Poppins, sans-serif',
        },
        legends: {
          text: {
            fontSize: 12,
          },
        },
      }}
    />
  );
};

export { Line };
